"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.api = api;
exports.get = get;
exports.getWithRedirect = getWithRedirect;
exports.post = post;
async function api(path, config) {
  const request = new Request(path, config);
  const response = await fetch(request);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  return response.json().catch(() => ({}));
}
async function get(path, config) {
  const init = {
    method: "get",
    ...config
  };
  return await api(path, init);
}
async function post(path, body, config) {
  const init = {
    method: "post",
    body: body instanceof FormData ? body : JSON.stringify(body),
    ...config
  };
  return await api(path, init);
}
async function getWithRedirect(path, config) {
  const request = new Request(path, {
    method: "get",
    ...config
  });
  const response = await fetch(request);
  if (!response.ok) {
    throw new Error(response.statusText);
  }
  if (response.redirected === true) {
    return {
      redirected: true,
      url: response.url
    };
  }
  return response.json().catch(() => ({}));
}